module.exports = __webpack_public_path__ + "img/background@2x.c2b51482.jpg";